import EpisodeShelfList from './episode-shelf-list';

export default EpisodeShelfList;
